<!-- 班级历史成绩对比四象限图 -->
<template>
    <div class="fourQuadrants-box">
        <div :id='"historyChart" + id_type' class="historyChart"></div>
    </div>
</template>
<script>
export default {
    props: ['id_type', 'chartData', 'gradeId'],
    data() {
        return {
            id_types: {
                1: '24秋前测',
                2: '月测2',
                3: '月测3',
                4: '25春前测',
            },
            average: {
                1: [78.6, 71.1],
                2: [64, 66.7],
                3: [61.6, 70.1],
                4: [62.4, 68.9],
                5: [61.5, 68.1],
                6: [60.4, 71]
            },
            dialogVisible: false
        }
    },
    watch: {
        chartData: {
            handler() {
                this.initChart()
            },
            deep: true,
        }
    },
    methods: {
        initChart() {
            this.$echarts.init(document.getElementById(`historyChart${this.id_type}`)).dispose();
            let myChart = this.$echarts.init(document.getElementById(`historyChart${this.id_type}`));
            let data = []
            // x轴数据 = 居中+占格+组合+多画的平均分
            // y轴数据 = 重心+笔画+收放的平均分
            this.chartData.stuList.map(item => {
                let xData = ((Number(item.centerPos) + Number(item.gridSize) + Number(item.comboRel) + Number(item.multiDist)) / 4).toFixed(2);
                let yData = ((Number(item.glyphGrav) + Number(item.strokeRel) + Number(item.rewindRel)) / 3).toFixed(2);
                let obj = {
                    name: item.stuName,
                    value: [xData, yData]
                }
                data.push(obj)
            })
            console.log('data', data);
            
            myChart.setOption({
                title: {
                    text: this.chartData.examName,
                    left: 'center',
                    textStyle: {
                        fontWeight: "normal"
                    },
                },
                tooltip: {
                    show: true,
                    trigger: 'item',
                    formatter: (params) => `${params.name}( 努力:${params.value[0]},天赋:${params.value[1]})`,
                    position: 'right'
                },
                xAxis: {
                    type: 'value',
                    min: 40,
                    max: 100,
                    axisLine: {
                        onZero: false,
                        // show: false
                    },
                    // axisTick: { show: false }, // 隐藏刻度线
                    // axisLabel: { show: false },
                    splitLine: {
                        show: false   // ❗ 不显示网格线
                    },
                    interval: 10,
                },
                yAxis: {
                    type: 'value',
                    min: 40,
                    max: 100,
                    axisLine: {
                        onZero: false,
                        // show: false
                    },
                    // axisTick: { show: false }, // 隐藏刻度线
                    // axisLabel: { show: false },
                    splitLine: {
                        show: false   // ❗ 不显示网格线
                    },
                    interval: 10,
                },
                series: [
                    {
                        type: 'scatter',
                        label: {
                            show: true,
                            position: 'top',
                            formatter: params => params.data.name,
                            fontSize: 10,
                            color: '#333'
                        },
                        data,
                        itemStyle: {
                            color: '#5470C6'
                        },
                        markLine: {
                            symbol: ['none', 'arrow'],
                            silent: true,
                            data: [
                                {
                                    xAxis: 69.32, // 纵轴线
                                    label: {
                                        show: true,
                                        position: 'start',
                                        formatter: '大众型'
                                    }
                                },
                                {
                                    yAxis: 64.75, // 横轴线
                                    label: {
                                        show: true,
                                        position: 'start',
                                        formatter: '自然成长'
                                    }
                                },
                                {
                                    xAxis: 69.32, // 纵轴线
                                    label: {
                                        show: true,
                                        position: 'end',
                                        formatter: '天赋型'
                                    }
                                },
                                {
                                    yAxis: 64.75, // 横轴线
                                    label: {
                                        show: true,
                                        position: 'end',
                                        formatter: '笃行不倦'
                                    }
                                }
                            ],
                            // data: [
                            //     {
                            //         xAxis: this.average[this.gradeId][1], // 纵轴线
                            //         label: {
                            //             show: true,
                            //             position: 'start',
                            //             formatter: '大众型'
                            //         }
                            //     },
                            //     {
                            //         yAxis: this.average[this.gradeId][0], // 横轴线
                            //         label: {
                            //             show: true,
                            //             position: 'start',
                            //             formatter: '自然成长'
                            //         }
                            //     },
                            //     {
                            //         xAxis: this.average[this.gradeId][1], // 纵轴线
                            //         label: {
                            //             show: true,
                            //             position: 'end',
                            //             formatter: '天赋型'
                            //         }
                            //     },
                            //     {
                            //         yAxis: this.average[this.gradeId][0], // 横轴线
                            //         label: {
                            //             show: true,
                            //             position: 'end',
                            //             formatter: '笃行不倦'
                            //         }
                            //     }
                            // ],
                            lineStyle: {
                                type: 'solid',
                                color: '#aaa'
                            }
                        }
                    }
                ],
                dataZoom: [
                    {
                        type: 'inside',
                        startValue: 40,
                        endValue: 100,
                        // start: 30, // 显示哪一段，比如只显示中间 30% ~ 70%
                        // end: 50
                    }
                ],
                grid: {
                    left: '15%',              // 网格左侧的距离
                    right: '15%',
                }
            })
        },
    },
    mounted() {
        // 初始化图表
        this.initChart()
    }
}
</script>
<style lang="less">
.fourQuadrants-box {
    box-sizing: border-box;
    padding: 0 20px;
    width: 100%;
    height: 600px;

    // border: 1px solid #ccc;
    margin-bottom: 30px;

    .historyChart {
        width: 100%;
        height: 100%;
    }
}
</style>